import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { PlFlag, UsFlag } from "@/components/site/Flags";

export const LangSwitch = ({ testId = "lang-switch" }) => {
  const { t, other } = useLang();
  const Flag = other === "pl" ? PlFlag : UsFlag;
  return (
    <Link
      to={other === "pl" ? "/pl/" : "/"}
      hrefLang={other}
      lang={other}
      title={t.header.switchLabel}
      aria-label={t.header.switchLabel}
      data-testid={testId}
      className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#D3CEC4] hover:border-[#1A2522] transition-colors"
    >
      <Flag className="w-6 h-auto rounded-[2px] shadow-[0_0_0_1px_rgba(26,37,34,0.15)]" />
    </Link>
  );
};
